import router from '@/router';
import { ServicesContainer } from '@/services';
import { TwoStepVerificationEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AnalyticsEventType, WebPageDetails } from '../models';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeTwoStepVerificationEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.PageLoaded;
  
  constructor(event: TwoStepVerificationEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    switch(event.twoStepVerificationEvent) {
      case AnalyticsEventType.TwoStepVerificationStart:
      case AnalyticsEventType.TwoStepVerificationLockout:
        this.web.webPageDetails = this.getWebPageDetails(store.state.ui.countryProfile.countryCode);
        this.web.webPageDetails.name = event.twoStepVerificationEvent == AnalyticsEventType.TwoStepVerificationStart ? 'account:2sv' : window.location.origin + router.currentRoute.fullPath;
        this.web.webPageDetails.pageType = 'account';
        this.web.webPageDetails.pageViews = { value: 1 };
        this.web.webPageDetails.siteSection = 'account';
        this.web.webPageDetails.subPageName = 'account:2sv';
        this.web.webPageDetails.subPageViews = { value: 1 };
        this.account[event.twoStepVerificationEvent] = { value: 1 };
        break;
      
      case AnalyticsEventType.TwoStepVerificationComplete:
      case AnalyticsEventType.TwoStepVerificationInvalidMax:
      case AnalyticsEventType.TwoStepVerificationInvalid:
        this.web.webPageDetails = this.getWebPageDetails(store.state.ui.countryProfile.countryCode);
        this.event = AnalyticsEventType.StatusChanged;
        this.account = { ... this.account, [event.twoStepVerificationEvent]: { value: 1 }};
        break;

      case AnalyticsEventType.TwoStepVerificationResendCode:
      case AnalyticsEventType.TwoStepVerificationGetSupport:
        this.event = AnalyticsEventType.LinkClicked;
        const linkModule = AnalyticsEventType.TwoStepVerificationResendCode == event.twoStepVerificationEvent ? 'resend-code' : 'contact-customer-care';
        this.web.webInteraction = { linkClicks: {value: 1}, linkModuleName: `account|2sv|${linkModule}` };
        this.account[event.twoStepVerificationEvent] = { value: 1 };
        break;
    }
  }

  getWebPageDetails(countryCode: string): WebPageDetails {
    return {
      ... this.web.webPageDetails,
      siteRegion: countryCode,
      URL: window.location.origin + router.currentRoute.fullPath,
    };
  }
}